import { useState } from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: white;
  padding: 24px;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  text-align: center;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const ButtonSave = styled.button`
  background: #007bff;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #0056b3;
  }
`;

const ButtonCancel = styled.button`
  background: #ccc;
  color: black;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background: #aaa;
  }
`;


interface EditPersonModalProps {
  person: {
    id: string;
    name: string;
    gender: string;
    phone?: string;
    img?: string;
    birth?: string;
    dead?: string;
    address?: string;
  };
  onClose: () => void;
  onSave: () => void;
}

export const EditPersonModal = ({ person, onClose, onSave }: EditPersonModalProps) => {
  const [formData, setFormData] = useState({
    name: person.name || "",
    gender: person.gender || "male",
    phone: person.phone || "",
    img: person.img || "",
    birth: person.birth || "",
    dead: person.dead || "",
    address: person.address || "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(location.protocol + '//saadacohen.com/server/edit_person.php', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: person.id,
          ...formData,
        }),
      });

      const text = await response.text();
      if (!response.ok) {
        throw new Error(text);
      }

      onSave();
      onClose();
    } catch (error) {
      console.error("Error updating person:", error);
      alert("אירעה שגיאה בעדכון");
    }
  };

  return (
    <Overlay>
      <Modal>
        <Title>עריכת פרטי אדם</Title>
        <Form>
          <Input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="שם"
          />
          <Select name="gender" value={formData.gender} onChange={handleChange}>
            <option value="male">זכר</option>
            <option value="female">נקבה</option>
          </Select>
          <Input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="טלפון"
          />
          <Input
            name="img"
            value={formData.img}
            onChange={handleChange}
            placeholder="קישור לתמונה"
          />
          <Input
            name="birth"
            value={formData.birth}
            onChange={handleChange}
            placeholder="תאריך לידה עברי"
          />
          <Input
            name="dead"
            value={formData.dead}
            onChange={handleChange}
            placeholder="תאריך פטירה עברי"
          />
          <Input
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="כתובת"
          />
        </Form>

        <ButtonGroup>
          <ButtonCancel onClick={onClose}>ביטול</ButtonCancel>
          <ButtonSave onClick={handleSubmit}>שמירה</ButtonSave>
        </ButtonGroup>
      </Modal>
    </Overlay>
  );
};

export default EditPersonModal;
